import React, {useContext, useEffect, useState} from 'react';

import {Card, CardContent, Grid} from "@mui/material";
import MobileItem from "components/WMS/Mobile/MobileItem";
import {FormattedMessage} from "react-intl";
import {ReactComponent as ArrowRightIcon} from "assets/img/wms/arrow-right.svg";
import ToBeSortedSingleTrolley from "./ToBeSortedSingleTrolley/ToBeSortedSingleTrolley";
import {getTrolleyWithReadyToBeSortedItem, getWMSContainerWithCodeBar} from "api/wms/wmsContainers/wmsContainers";
import {WMSContext} from "../../context/WMSContext";
import {BarCodeScannerContext} from "contexts/barCodeScannerContext";

import {WMSRoutes} from "utils/WMSRoutes";

import NoTrolleyPopup from "./NoTrolleyPopup";

function ToBeSortedTrolleys() {
    const {currentInventory, currentMember, currentOrganization, redirect} = useContext(WMSContext)
    const {scannedString, setEnableScan} = useContext(BarCodeScannerContext)
    const [trolleys, setTrolleys] = useState([])
    const [selectedTrolley, setSelectedTrolley] = useState()
    const [selectedTrolleyIndex, setSelectedTrolleyIndex] = useState(0)
    const [openRightDrawer, setOpenRightDrawer] = useState(false)
    const [isScanned, setIsScanned] = useState(false)
    const [loading, setLoading] = useState(false)
    const [massTransfer, setMassTransfer] = useState(false)

    const openDrawer = (trolley, trolleyIndex) => {
        setSelectedTrolley(trolley)
        setSelectedTrolleyIndex(trolleyIndex)
        setOpenRightDrawer(true);
    }

    const handleRefreshTrolley = (trolley) => {
        getWMSContainerWithCodeBar(trolley.codebar).then(response => {
            setSelectedTrolley(response)
        })
    }

    function listTrolleys() {
        setLoading(true)
        getTrolleyWithReadyToBeSortedItem(currentInventory).then((response) => {
            setTrolleys(response)
            setEnableScan(true)
        }).finally(() => {
            setLoading(false)
        })
    }

    useEffect(() => {
        if (scannedString && scannedString.length > 0 && !openRightDrawer) {
            setEnableScan(false)
            trolleys.forEach((trolley) => {
                if (trolley.codebar === scannedString) {
                    setIsScanned(true)
                    setSelectedTrolley(trolley)
                    setOpenRightDrawer(true)
                } else {
                    setEnableScan(true)
                }
            })
        }
    }, [scannedString]);

    useEffect(() => {
        if (false === openRightDrawer && selectedTrolley) {
            setSelectedTrolley(undefined)
            setIsScanned(false)
        }
    }, [openRightDrawer]);

    useEffect(() => {
        if (currentInventory && false === openRightDrawer) {
            listTrolleys();
        }
    }, [currentInventory, openRightDrawer]);

    // when coming from picking view
    useEffect(() => {
        const currentMemberTrolley = trolleys.find((trolley) => trolley.member?.id && trolley.member.id === currentMember.id)

        if (currentMemberTrolley) {
            setSelectedTrolley(currentMemberTrolley);
            setOpenRightDrawer(true);
        }
    }, [trolleys]);

    useEffect(() => {
        if (currentOrganization) {
            setMassTransfer(currentOrganization.massTransfer ? currentOrganization.massTransfer : false )
        }
    }, [currentOrganization]);

    if (0 === trolleys.filter((trolley) => !trolley.member).length && loading === false && !selectedTrolley) {
        return (
            <NoTrolleyPopup
                open={true}
                handleClose={() => redirect(WMSRoutes.DASHBOARD)}
                onClick={() => listTrolleys()}
            />
        )
    }

    return (
        <>
            {selectedTrolley && (
                <ToBeSortedSingleTrolley
                    open={openRightDrawer}
                    setOpen={setOpenRightDrawer}
                    trolley={selectedTrolley}
                    currentMember={currentMember}
                    isScanned={isScanned}
                    trolleyIndex={selectedTrolleyIndex}
                    refreshTrolley={handleRefreshTrolley}
                    massTransfer={massTransfer}
                />

            )}
            <Card sx={{
                marginBottom: '32px',
                boxShadow: 0,
                padding: '0 0',
            }}>
                <CardContent sx={{paddingX: 0}}>
                    <Grid container direction={"column"}>
                        {trolleys.filter((trolley) => !trolley.member).map((trolley, index) => {
                            let containMulti = false
                            let containMono = false
                            trolley.wmsItems.forEach((item) => {
                                if (item.
                                    lineItem.currentShipment.multi && !containMulti) {
                                    containMulti = true
                                }

                                if (!item.lineItem.currentShipment.multi && !containMono) {
                                    containMono = true
                                }
                            })
                            return (
                                <Grid item key={trolley.id}>
                                    <div onClick={() => openDrawer(trolley, index + 1)}>
                                        <MobileItem>
                                            <MobileItem.LeftSide
                                                title={<><FormattedMessage
                                                    id={'wms.sorting.inSorting.trolley.title'}/> {trolley.name ?? (index + 1)}</>}
                                                subtitle={
                                                    <>
                                                        {containMulti && <FormattedMessage id={"wms.sorting.multi"}/>}
                                                        {containMulti && containMono && "/"}
                                                        {containMono && <FormattedMessage id={"wms.sorting.mono"}/>} · {trolley.wmsItems.length} <FormattedMessage id={"wms.sorting.article"}/>
                                                    </>
                                            }
                                            />
                                            <MobileItem.RightSide>
                                                <ArrowRightIcon/>
                                            </MobileItem.RightSide>
                                        </MobileItem>
                                    </div>
                                </Grid>
                            )
                            }
                        )}
                    </Grid>
                </CardContent>
            </Card>
        </>

    );
}

export default ToBeSortedTrolleys;
